document.body.addEventListener('click', function (event) {
  if (!event.target.classList.contains('js-list-more')) return; // event.stopPropagation();

  var item = getFirstParentMatch(event.target, '.list__item');
  if (item) item.classList.toggle('opened');
}, true);

function getFirstParentMatch(element, selector) {
  if (!element) {
    return element;
  }

  element.matches(selector) || (element = element.nodeName.toLowerCase() === 'html' ? false : getFirstParentMatch(element.parentNode, selector));
  return element;
}